import { createSlice } from "@reduxjs/toolkit"
import {
  onGetServiceList,
  onAddService,
  onUpdateService,
  onDeleteService,
  onGetBookingList,
  onAddBooking,
  onUpdateBooking,
  onGetServiceCustomFormList,
  onAddServiceCustomForm,
  onUpdateServiceCustomForm,
  onDeleteServiceCustomForm,
  onGetServiceTypeList,
  onAddServiceType,
  onUpdateServiceType,
  onDeleteServiceType,
} from './thunk'

export const initialState = {
  serviceList: [],
  bookingList: [],
  serviceTypeList: [],
  customFormList: [],
  errors: {}
}

const BookingsSlice = createSlice({
  name: 'Booking',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // services
    builder.addCase(onGetServiceList.fulfilled, (state: any, action: any) => {
      state.serviceList = action.payload;
    });
    builder.addCase(onGetServiceList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddService.fulfilled, (state: any, action: any) => {
      state.serviceList.unshift(action.payload);
    });
    builder.addCase(onAddService.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateService.fulfilled, (state: any, action: any) => {
      state.serviceList = state.serviceList.map((list: any) =>
        list.serviceId === action.payload.serviceId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateService.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteService.fulfilled, (state: any, action: any) => {
      state.serviceList = state.serviceList.filter(
        (service: any) => service.serviceId.toString() !== action.payload.serviceId.toString()
      );
    });
    builder.addCase(onDeleteService.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // bookings
    builder.addCase(onGetBookingList.fulfilled, (state: any, action: any) => {
      state.bookingList = action.payload;
    });
    builder.addCase(onGetBookingList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddBooking.fulfilled, (state: any, action: any) => {
      state.bookingList.unshift(action.payload);
    });
    builder.addCase(onAddBooking.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateBooking.fulfilled, (state: any, action: any) => {
      state.bookingList = state.bookingList.map((list: any) =>
        list.serviceBookingId === action.payload.serviceBookingId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateBooking.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // custom-forms
    builder.addCase(onGetServiceCustomFormList.fulfilled, (state: any, action: any) => {
      state.customFormList = action.payload;
    });
    builder.addCase(onGetServiceCustomFormList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddServiceCustomForm.fulfilled, (state: any, action: any) => {
      state.customFormList.unshift(action.payload);
    });
    builder.addCase(onAddServiceCustomForm.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateServiceCustomForm.fulfilled, (state: any, action: any) => {
      state.customFormList = state.customFormList.map((list: any) =>
        list.serviceCustomFormId === action.payload.serviceCustomFormId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateServiceCustomForm.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteServiceCustomForm.fulfilled, (state: any, action: any) => {
      state.customFormList = state.customFormList.filter(
        (customForm: any) => customForm.serviceCustomFormId.toString() !== action.payload.serviceCustomFormId.toString()
      );
    });
    builder.addCase(onDeleteServiceCustomForm.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // service-type
    builder.addCase(onGetServiceTypeList.fulfilled, (state: any, action: any) => {
      state.serviceTypeList = action.payload;
    });
    builder.addCase(onGetServiceTypeList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddServiceType.fulfilled, (state: any, action: any) => {
      state.serviceTypeList.unshift(action.payload);
    });
    builder.addCase(onAddServiceType.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateServiceType.fulfilled, (state: any, action: any) => {
      state.serviceTypeList = state.serviceTypeList.map((list: any) =>
        list.serviceTypeId === action.payload.serviceTypeId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateServiceType.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteServiceType.fulfilled, (state: any, action: any) => {
      if (action.payload?.serviceTypeId) {
        state.serviceTypeList = state.serviceTypeList.filter(
          (serviceType: any) => serviceType.serviceTypeId.toString() !== action.payload.serviceTypeId.toString()
        );
      }
    });
    builder.addCase(onDeleteServiceType.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

  }
});

export default BookingsSlice.reducer;